import React, { ReactElement, ReactNode } from "react";
import Head from "next/head";
import { useModal } from "@hooks/useModalContext";
import dynamic from "next/dynamic";
import Mobile from "@components/shared/blogPost/sideWidget/mobile";

import MainLayout from "@components/storagecontainerprices/mainLayout";
const Modal = dynamic(() => import("@components/shared/modal"));
const CloseIcon = dynamic(() => import("@components/svg/closeIcon"));
const TermsAndConditions = dynamic(
    () => import("@components/shared/legal/termsAndConditions"),
);
const PrivacyPolicy = dynamic(
    () => import("@components/shared/legal/privacyPolicy"),
);

export default function StorageContainerWrapper({
    children,
}: {
    children: ReactNode;
}): ReactElement {
    const { modal, closeModal } = useModal();

    const handleClose = () => {
        closeModal();
    };

    const { active: modalActive, content: modalContent } = modal;

    const getModalContent = () => {
        switch (modalContent) {
            case "privacy":
                return (
                    <PrivacyPolicy
                        category="Storage Container"
                        domain="StorageContainerPrices.com"
                    />
                );
            case "terms":
                return (
                    <TermsAndConditions
                        category="Storage Container"
                        domain="StorageContainerPrices.com"
                    />
                );
            case "sideWidget":
                return <Mobile />;
            default:
                return null;
        }
    };

    return (
        <>
            <Head>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap"
                    rel="stylesheet"
                />
            </Head>

            <div style={{ fontFamily: `'Open Sans', sans-serif` }}>
                <div>
                    <MainLayout>{children}</MainLayout>
                </div>
                <Modal
                    onClose={handleClose}
                    active={modalActive}
                    closeIcon={<CloseIcon />}
                    backdropClosable
                    modalStyles={{
                        display: "flex",
                        flexDirection: "column",
                        maxHeight:
                            modalContent === "sideWidget" ? "80vh" : "100%",
                    }}
                    modalClassName="h-[90vh] rounded"
                    bodyStyles={{ overflowY: "scroll" }}
                    width={900}
                    header={
                        modalContent === "privacy"
                            ? "Privacy Policy"
                            : modalContent === "terms"
                            ? "Terms and Conditions"
                            : modalContent === "sideWidget"
                            ? "Contents"
                            : undefined
                    }
                >
                    {getModalContent()}
                </Modal>
            </div>
        </>
    );
}
